import { ICreateSendCrmLink, ICreateSendCrmState } from '../../types/createSendCrm';

const isString = (value: unknown): value is string => typeof value === 'string';

const isPersistableLink = (value: unknown): value is ICreateSendCrmLink => {
  if (typeof value !== 'object' || value === null || Array.isArray(value)) {
    return false;
  }

  const candidate = value as Partial<ICreateSendCrmLink>;

  return (
    isString(candidate.recordId) &&
    candidate.recordId.length > 0 &&
    isString(candidate.recordType) &&
    (candidate.opportunityId === null || isString(candidate.opportunityId))
  );
};

const pickPersistedLink = (link: ICreateSendCrmLink): ICreateSendCrmLink => ({
  recordId: link.recordId,
  recordType: link.recordType,
  opportunityId: link.opportunityId ?? null,
});

export const normalizePersistedCrmLinks = (value: unknown): Record<string, ICreateSendCrmLink> => {
  if (typeof value !== 'object' || value === null || Array.isArray(value)) {
    return {};
  }

  return Object.entries(value as Record<string, unknown>).reduce<Record<string, ICreateSendCrmLink>>(
    (acc, [uid, link]) => (uid && isPersistableLink(link) ? { ...acc, [uid]: pickPersistedLink(link) } : acc),
    {},
  );
};

export const normalizePersistedCrm = (value: unknown): ICreateSendCrmState => {
  const candidate = (typeof value === 'object' && value !== null ? value : {}) as Partial<ICreateSendCrmState>;

  return {
    byRecipientUid: normalizePersistedCrmLinks(candidate.byRecipientUid),
    pending: null,
    shipment: isPersistableLink(candidate.shipment) ? pickPersistedLink(candidate.shipment) : null,
  };
};
